'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var URL = exports.URL = 'URL';
var QUERY_PARAM = exports.QUERY_PARAM = 'QUERY_PARAM';